export default function getConsentQuota(provisions) {
  if ( !provisions ) {
    return
  }

  const consentQuotaProvision = provisions
    .find(({ key }) => key === 'consent_quota')

  const count = consentQuotaProvision?.config?.operation_count

  return ( count < 0 ) ? Infinity : count
}
